import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'

export const AttributionChannelItem = styled.div`
  height: 7.5vh;
  max-height: 61px;
  width: 40vw;
  max-width: 158px;
  box-shadow: 0 4px 13px rgba(43, 5, 20, 0.04);
  transition: box-shadow 0.3s;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.grayDark};
  font-size: 18px;
  margin: 0 5px 12px 5px;
  position: relative;

  &:hover {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);
  }
`

export const AttributionChannelSelector = styled.div`
  user-select: none;
  width: 100%;
  max-width: 350px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 1;
  ${onMediumScreen()} {
    width: 550px;
    max-width: none;
  }
`
